"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TagCollectionActions;
(function (TagCollectionActions) {
    TagCollectionActions["TagAdded"] = "TagAdded";
    TagCollectionActions["TagRemoved"] = "TagRemoved";
    TagCollectionActions["FilterTagsSet"] = "FilterTagsSet";
})(TagCollectionActions || (TagCollectionActions = {}));
exports.default = TagCollectionActions;
